import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ colors, spacing, flags }: Theme) => createStyles({
  row: {
    background: colors.pageElements.table.background,
  },
  cell: {
    borderBottomColor: colors.pageElements.table.headerDivider,
    borderBottomStyle: 'solid',
    borderBottomWidth: flags.boxStyle === 'stroke' ? 2 : 1,
    padding: spacing(2),
    '&:last-child': {
      paddingRight: 0,
    },
  },
  sortIcon: {
    display: 'flex',
    marginLeft: spacing(1),
    color: `${colors.pageElements.table.headerCell.enabled.icon} !important`,
    '&:hover': {
      color: `${colors.pageElements.table.headerCell.hovered.icon} !important`,
    },
    '& > svg': {
      fill: 'currentColor',
    },
  },
  simpleLabel: {
    color: colors.pageElements.table.headerCell.enabled.name,
    '&:hover': {
      color: colors.pageElements.table.headerCell.hovered.name,
    },
  },
  label: {
    color: colors.pageElements.table.headerCell.enabled.name,
    '&$activeLabel': {
      color: colors.pageElements.table.headerCell.enabled.name,
    },
    '&:hover': {
      color: colors.pageElements.table.headerCell.hovered.name,
      '& $sortIcon': {
        opacity: 1,
      },
    },
  },
  activeLabel: {},
});

export default styles;
